// extracted by mini-css-extract-plugin
export default {"walkthroughContainer":"walkthrough_walkthroughContainer__K18mB","title":"walkthrough_title__X77eZ","video":"walkthrough_video__4Kemu"};